class AnnouncementBarComponent extends HTMLElement {
  constructor() {
    super();
    this.currentSlide = 0;
    this.slides = [];
    this.autoplayInterval = null;
    this.autoplaySpeed = 5000; // default 5 seconds
    this.isContinuous = false;
  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
    
    if (this.slides.length <= 1) return;

    // Get autoplay speed from attribute
    const autoplayAttr = this.getAttribute('autoplay');
    if (autoplayAttr) {
      this.autoplaySpeed = parseInt(autoplayAttr) * 1000;
    }

    // Check if continuous mode is enabled
    this.isContinuous = this.hasAttribute('data-continuous');

    this.initializeSlides();
    this.startAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
  }

  initializeSlides() {
    this.slides.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== 0 ? 'true' : 'false');
    });
  }

  showSlide(index) {
    this.slides.forEach((slide, i) => {
      slide.setAttribute('aria-hidden', i !== index ? 'true' : 'false');
    });
    this.currentSlide = index;
  }

  nextSlide() {
    const nextIndex = (this.currentSlide + 1) % this.slides.length;
    this.showSlide(nextIndex);
  }

  startAutoplay() {
    if (this.slides.length <= 1) return;
    
    this.stopAutoplay(); // Clear any existing interval
    this.autoplayInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoplaySpeed);
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  // Override default behaviors that would stop autoplay
  handleMouseEnter() {
    // In continuous mode, don't stop autoplay on hover
    if (!this.isContinuous) {
      this.stopAutoplay();
    }
  }

  handleMouseLeave() {
    // Always restart autoplay when mouse leaves
    if (!this.isContinuous) {
      this.startAutoplay();
    }
  }

  handleClick() {
    // In continuous mode, don't stop autoplay on click
    if (!this.isContinuous) {
      // Allow click events but maintain autoplay
      return;
    }
  }

  // Add event listeners if needed for non-continuous mode
  addEventListeners() {
    if (!this.isContinuous) {
      this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }
}

customElements.define('announcement-bar-component', AnnouncementBarComponent);